import {Injectable} from '@angular/core';
import {Http, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {UserService} from './user.service';

@Injectable()
export class IotService {

  getAll(): Observable<Array<IotData>> {
    return this.http.get('/api/iot/data', {'headers': this.us.getAuthHeaders()})
      .map((res: Response) => res.json().data)
      .catch((error: any) => Observable.throw(error.json().message || 'Server error'));
  };

  getAllFrom(id: number): Observable<Array<IotData>> {
    return this.http.get('/api/iot/data/from/' + id, {'headers': this.us.getAuthHeaders()})
      .map((res: Response) => res.json().data)
      .catch((error: any) => Observable.throw(error.json().message || 'Server error'));
  };

  constructor(private http: Http, private us: UserService) {
  };

}


export class IotData {
  constructor(public receivedDate: number, public id: number, public value: number, public mac: string) {
  };
}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/iot.service.ts